import { Icon } from "@iconify/react";
import { Box, IconButton } from "@mui/material";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
export const HeaderConfig = [
  {
    label: "Sl No.",
    id: "siNo",
  },
  {
    label: "FAQs",
    id: "question",
  },
  {
    label: "View/ Modify",
    id: "action",
    render: (data, onClick) => (
      <span>
        <IconButton onClick={() => onClick(data, "EDIT")}>
          <Icon
            icon="bx:edit"
            width="1.5rem"
            height="1.5rem"
            style={{ color: "#093986" }}
          />
        </IconButton>
        <IconButton onClick={() => onClick(data, "DELETE")}>
          <DeleteTwoToneIcon color="error" />
        </IconButton>
      </span>
    ),
  },
];
export const getFaqFormConfig = () => [
  {
    name: "question",
    type: "textarea",
    label: "Question",
    placeholder: "Question",
    required: true,
    fieldGridSize: 12,
  },
  // {
  //   name: "answer",
  //   type: "textarea",
  //   label: "Answer",
  //   placeholder: "Answer",
  //   required: true,
  //   fieldGridSize: 12,
  // },
];
